/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */


/* eslint-enable no-console */
document.addEventListener('DOMContentLoaded', function() {
    const menuToggle = document.createElement('div');
    for (let i = 0; i < 3; i++) {
        const span = document.createElement('span');
        menuToggle.appendChild(span);
    }
    menuToggle.classList.add('menu-toggle');
    //menuToggle.innerHTML = '&#9776;'; // Hamburger icon symbol
    //menuToggle.innerHTML = ''; // Hamburger icon symbol

    const menuClose = document.createElement('div');
    menuClose.classList.add('menu-close');
    menuClose.innerHTML = '&times;'; // Close icon symbol    
 
    
    const navMenu = document.querySelector('.wp-block-compusol-dimizu-classic-menu-block');
    const subMenus = document.querySelectorAll('.wp-block-compusol-dimizu-classic-menu-block .menu .sub-menu');

    // Add handlers for menu items with children
    const menuItemsWithChildren = document.querySelectorAll('.menu-item-has-children');
    
    menuItemsWithChildren.forEach(item => {
        const link = item.querySelector('a');
        const subMenu = item.querySelector('.sub-menu');
        
        // Add click handler 
        item.addEventListener('click', (e) => {
            // Find if click target is the link or any of its children
            const clickedLink = e.target.closest('a');
            if (e.target === item || (clickedLink && clickedLink === link)) {
                e.preventDefault();
                e.stopPropagation();
                
                // Close all other expanded menus except the current one
                menuItemsWithChildren.forEach(otherItem => {
                    if (otherItem !== item && otherItem.classList.contains('expanded')) {
                        otherItem.classList.remove('expanded');
                        const otherSubMenu = otherItem.querySelector('.sub-menu');
                        if (otherSubMenu) {
                            otherSubMenu.classList.add('collapsed');
                        }
                    }
                });
                
                // Toggle current menu
                item.classList.toggle('expanded');
                if (subMenu) {
                    subMenu.classList.toggle('collapsed');
                }
            }
        });
    });

	function closeNav(e) {
        // Find the closest anchor element from the clicked target
        const linkElement = e.target.closest('a');
        if (!linkElement) return;
        
        // Check if the link's parent is not a dropdown menu item
        const parentItem = linkElement.closest('li');
        if (parentItem && 
            !parentItem.classList.contains('menu-item-has-children') && 
            linkElement.getAttribute('href') !== '#') {
            
            navMenu.classList.remove('show');
            document.body.classList.remove('menu-is-open');
            
            // Collapse all expanded menus
            document.querySelectorAll('.menu-item-has-children.expanded').forEach(item => {
                item.classList.remove('expanded');
                const subMenu = item.querySelector('.sub-menu');
                if (subMenu) {
                    subMenu.classList.add('collapsed');
                }
            });
        }
    }


    menuToggle.addEventListener('click', function() {
        navMenu.classList.toggle('show');
        document.body.classList.toggle('menu-is-open');
        menuToggle.classList.toggle('offen');
    });

    menuClose.addEventListener('click', function() {
        navMenu.classList.remove('show');
        document.body.classList.remove('menu-is-open');
    });

    //   Add event listener to close the overlay when any link is clicked
    var links = document.querySelectorAll(".menu a");
    links = Array.from(links).filter(link => link.getAttribute('href') !== '#');
    links.forEach(function(link) {
        link.addEventListener("click", closeNav);
    });
    

    document.querySelector('.wp-block-compusol-dimizu-classic-menu-block').appendChild(menuToggle);
    document.querySelector('.wp-block-compusol-dimizu-classic-menu-block').appendChild(menuClose);

    // Initialize all sub-menus as collapsed in mobile view
    function initializeMenuState() {
        // if (window.innerWidth < 768) {
            document.querySelectorAll('.sub-menu').forEach(subMenu => {
                subMenu.classList.add('collapsed');
            });
        // }
    }

    // Run initialization
    initializeMenuState();

    // Update menu state on resize
    window.addEventListener('resize', initializeMenuState);
});